import React from 'react'
import './modal-area-fall-2023.css'
import { freshSubtask } from '../../AdminTasks/adminTaskUtils'
import Subtask2023 from '../../TaskCardModal2023/Subtask2023/Subtask2023'
import { BsThreeDotsVertical } from 'react-icons/bs'
import DropdownWithImage from '../../DanitComponents/Dropdown/DropdownWithImage/DropdownWithImage'
import { modalOwnerOptions, modalSchoolOptions } from '../../StudentOnboardingFall2023/student-onboarding-fall-2023-info'
import { ButtonWithTrailingIconXLarge } from '../../DanitComponents/Buttons/ButtonWithTrailingIcon'
import { makeInquired, moveWaitlistToScheduling, moveToWaitlist, moveCardToScheduling, moveToOnboarding, deleteInquiryCardAndDeleteTheFamily, completeOnboardingCard, moveToIntro, moveToOffboard, fromLeavingToScheduling } from './modalAreaFunctionsFall2023'
import ModalDropdownMenuFall2023 from './ModalDropdownMenuFall2023/ModalDropdownMenuFall2023'
import TypeOfModalBadge2023 from './TypeOfModalBadge2023/TypeOfModalBadge2023'
import { PrimaryButtonLarge } from '../../DanitComponents/Buttons/PrimaryButton'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import MuiPickerForCardModals from '../../MuiPickerForCardModals'
import InquiredReasonPopup from '../../InquiredReasonPopup/InquiredReasonPopup'


const ModalAreaFall2023 = ({
    studentOnboardingModal, 
    setOpenWorkflowModal2023, 
    pushNewCardToOnBoardingCardsAndCloseModal, 
    removedCardAndCloseModal,
    getFamilyData, 
    updateExistingCardAndCloseModal, 
    pushNewCardAndRemoveOldCardAndCloseModal,
    pushNewCardAndRemoveGhostLeavingCardAndCloseModal,
    removeCardAndLaunchConfetti,
    setWarningPopup,
    removedCardAndCloseModalOpenConfirmationPopup,
    teacherAssignmentControl,
    contactPreferenceControl
}) => {
    const [openDropdown, setOpenDropdown] = React.useState(false)
    const [showInquiredReasonPopup, setShowInquiredReasonPopup] = React.useState(false)

    const closeInquiredReasonPopup = React.useCallback(() => {
        setShowInquiredReasonPopup(false)
    }, [])

    const openInquiredReasonPopup = React.useCallback(() => {
        setWarningPopup(false)
        setShowInquiredReasonPopup(true)
    }, [setWarningPopup])

    const openMakeInquiredConfirmation = React.useCallback(() => {
        setWarningPopup({
            type: 'confirm',
            title: `Make ${studentOnboardingModal.todoName} Family "Inquired"?`,
            message: `This will change their status to "Inquired" and delete them from the onboarding page.`,
            onConfirm: {
                text: 'Yes, Change to Inquired',
                action: openInquiredReasonPopup
            },
            onCancel: {
                text: 'Go Back',
                action: () => setWarningPopup(false)
            }
        })
    }, [openInquiredReasonPopup, setWarningPopup, studentOnboardingModal.todoName])

    const confirmMakeInquired = React.useCallback((reason) => {
        setShowInquiredReasonPopup(false)
        makeInquired(
            studentOnboardingModal.familyId,
            removedCardAndCloseModalOpenConfirmationPopup,
            'inquired',
            reason
        )
    }, [removedCardAndCloseModalOpenConfirmationPopup, studentOnboardingModal.familyId])

    const cardLayout = {
        inquiry:{
            type: 'inquiry',
            adminAssignable: true,
            schoolAssignable: true,
            introLessonDate: false,
            dropDownMenuOptions: [
                {
                    label: 'Make "Inquired"',
                    onClick: openMakeInquiredConfirmation
                },
                {
                    label: 'Move to waitlist',
                    onClick: () => moveToWaitlist(studentOnboardingModal.familyId, removedCardAndCloseModal)
                },
                {
                    label: 'Move to scheduling',
                    onClick: () => moveCardToScheduling(studentOnboardingModal.familyId, studentOnboardingModal.todoId, pushNewCardAndRemoveOldCardAndCloseModal)
                },
                {
                    label: 'Open Family Profile',
                    onClick: () => getFamilyData(studentOnboardingModal.familyId)
                },
                {
                    label: 'Delete card',
                    onClick: () => removedCardAndCloseModalOpenConfirmationPopup(studentOnboardingModal, 'deleteCardOnly')
                },
                {
                    label: 'Delete family',
                    onClick: () => setWarningPopup({
                        type: 'warning',
                        title: `Are you sure?`,
                        message: `This will delete this customer from the database permanently. This cannot be undone.  `,
                        onConfirm: {
                            text: 'Yes, Delete',
                            action: () => deleteInquiryCardAndDeleteTheFamily(studentOnboardingModal.todoId, studentOnboardingModal.familyId, removedCardAndCloseModalOpenConfirmationPopup, 'deleted')
                        },
                        onCancel: {
                            text: 'Go Back',
                            action: () => setWarningPopup(false)
                        }
                    })
                },
            ],
            showCheckList: true,
            addTaskButton: true,
            moveForwardButton: {
                label: 'Move to Scheduling',
                onClick: () => moveCardToScheduling(studentOnboardingModal.familyId, studentOnboardingModal.todoId, pushNewCardAndRemoveOldCardAndCloseModal)
            }
        },
        scheduling: {
            type: 'scheduling',
            adminAssignable: true,
            schoolAssignable: true,
            introLessonDate: false,
            dropDownMenuOptions: [
                {
                    label: 'Make "Inquired"',
                    onClick: openMakeInquiredConfirmation
                },
                {
                    label: 'Move to waitlist',
                    onClick: () => moveToWaitlist(studentOnboardingModal.familyId, removedCardAndCloseModal)
                },
                {
                    label: 'Open Family Profile',
                    onClick: () => getFamilyData(studentOnboardingModal.familyId)
                },
                {
                    label: 'Delete card',
                    onClick: () => removedCardAndCloseModalOpenConfirmationPopup(studentOnboardingModal, 'deleteCardOnly')
                },
                {
                    label: 'Delete family',
                    onClick: () => setWarningPopup({
                        type: 'warning',
                        title: `Are you sure?`,
                        message: `This will delete this customer from the database permanently. This cannot be undone.  `,
                        onConfirm: {
                            text: 'Yes, Delete',
                            action: () => deleteInquiryCardAndDeleteTheFamily(studentOnboardingModal.todoId, studentOnboardingModal.familyId, removedCardAndCloseModalOpenConfirmationPopup, 'deleted')
                        },
                        onCancel: {
                            text: 'Go Back',
                            action: () => setWarningPopup(false)
                        }
                    })
                },
            ],
            showCheckList: true,
            addTaskButton: true,
            moveForwardButton: {
                label: 'Intro Scheduled',
                onClick: () => moveToIntro(studentOnboardingModal.todoId, updateExistingCardAndCloseModal)
            },
            // moveForwardButton: {
            //     label: 'To Onboarding',
            //     onClick: () => moveToOnboarding(studentOnboardingModal.todoId, updateExistingCardAndCloseModal)
            // },
        },
        intro: {
            type: 'intro',
            adminAssignable: true,
            schoolAssignable: true,
            introLessonDate: true,
            datePickerLabel: 'Intro Lesson',
            dropDownMenuOptions: [
                {
                    label: 'Make "Inquired"',
                    onClick: openMakeInquiredConfirmation
                },
                {
                    label: 'Move to waitlist',
                    onClick: () => moveToWaitlist(studentOnboardingModal.familyId, removedCardAndCloseModal)
                },
                {
                    label: 'Back to scheduling',
                    onClick: () => moveCardToScheduling(studentOnboardingModal.familyId, studentOnboardingModal.todoId, pushNewCardAndRemoveOldCardAndCloseModal)
                },
                {
                    label: 'Open Family Profile',
                    onClick: () => getFamilyData(studentOnboardingModal.familyId)
                },
                {
                    label: 'Delete card',
                    onClick: () => removedCardAndCloseModalOpenConfirmationPopup(studentOnboardingModal, 'deleteCardOnly')
                },
            ],
            showCheckList: true,
            addTaskButton: true,
            moveForwardButton: {
                label: 'Onboard',
                onClick: () => moveToOnboarding(studentOnboardingModal.todoId, updateExistingCardAndCloseModal)
            },
            redButton: {
                label: 'Offboard',
                onClick: () => moveToOffboard(studentOnboardingModal.todoId, updateExistingCardAndCloseModal)
            },
            neutralButton: {
                label: 'Back To Scheduling',
                onClick: () => moveCardToScheduling(studentOnboardingModal.familyId, studentOnboardingModal.todoId, pushNewCardAndRemoveOldCardAndCloseModal)
            },
        },
        onboarding: {
            type: 'onboarding',
            adminAssignable: true,
            schoolAssignable: true,
            introLessonDate: false,
            dropDownMenuOptions: [
                {
                    label: 'Make "Inquired"',
                    onClick: openMakeInquiredConfirmation
                },
                {
                    label: 'Move to waitlist',
                    onClick: () => moveToWaitlist(studentOnboardingModal.familyId, removedCardAndCloseModal)
                },
                {
                    label: 'Back to scheduling',
                    onClick: () => moveCardToScheduling(studentOnboardingModal.familyId, studentOnboardingModal.todoId, pushNewCardAndRemoveOldCardAndCloseModal)
                },
                {
                    label: 'Open Family Profile',
                    onClick: () => getFamilyData(studentOnboardingModal.familyId)
                },
                {
                    label: 'Delete card',
                    onClick: () => removedCardAndCloseModalOpenConfirmationPopup(studentOnboardingModal, 'deleteCardOnly')
                },
            ],
            showCheckList: true,
            addTaskButton: true,
            moveForwardButton: {
                label: 'Complete Onboarding',
                onClick: () => completeOnboardingCard(studentOnboardingModal, removeCardAndLaunchConfetti)
            },
        },
        teacher: {
            type: 'teacher',
            adminAssignable: true,
            schoolAssignable: true,
            introLessonDate: true,
            datePickerLabel: 'Starting Date',
            dropDownMenuOptions: [
                {
                    label: 'Delete card',
                    onClick: () => removedCardAndCloseModalOpenConfirmationPopup(studentOnboardingModal, 'deleteCardOnly')
                },
            ],
            showCheckList: true,
            addTaskButton: true,
            moveForwardButton: {
                label: 'Complete Onboarding',
                onClick: () => removedCardAndCloseModalOpenConfirmationPopup(studentOnboardingModal, 'deleteCardOnly')
            },
        },
        offboard: {
            type: 'offboard',
            adminAssignable: true,
            schoolAssignable: true,
            introLessonDate: false,
            dropDownMenuOptions: [
                {
                    label: 'Make "Inquired"',
                    onClick: openMakeInquiredConfirmation
                },
                {
                    label: 'Move to waitlist',
                    onClick: () => moveToWaitlist(studentOnboardingModal.familyId, removedCardAndCloseModal)
                },
                {
                    label: 'Back to scheduling',
                    onClick: () => moveCardToScheduling(studentOnboardingModal.familyId, studentOnboardingModal.todoId, pushNewCardAndRemoveOldCardAndCloseModal)
                },
                {
                    label: 'Open Family Profile',
                    onClick: () => getFamilyData(studentOnboardingModal.familyId)
                },
                {
                    label: 'Delete card',
                    onClick: () => removedCardAndCloseModalOpenConfirmationPopup(studentOnboardingModal, 'deleteCardOnly')
                },
            ],
            showCheckList: true,
            addTaskButton: true,
            moveForwardButton: {
                label: 'Complete Offboarding',
                onClick: () => removedCardAndCloseModalOpenConfirmationPopup(studentOnboardingModal, 'deleteCardOnly')
            },
        },
        waitlist: {
            type: 'waitlist',
            adminAssignable: false,
            schoolAssignable: true,
            introLessonDate: false,
            dropDownMenuOptions: [
                {
                    label: 'Make "Inquired"',
                    onClick: openMakeInquiredConfirmation
                },
                {
                    label: 'Move to scheduling',
                    onClick: () => moveWaitlistToScheduling(studentOnboardingModal.familyId, pushNewCardToOnBoardingCardsAndCloseModal)
                },
                {
                    label: 'Open Family Profile',
                    onClick: () => getFamilyData(studentOnboardingModal.familyId)
                },
            ],
            showCheckList: false,
            showMessageInsteadOfChecklist: 'Click the "To Scheduling" button to move this family to the scheduling workflow and off the waitlist.',
            addTaskButton: false,
            moveForwardButton: {
                label: 'To Scheduling',
                onClick: () => moveWaitlistToScheduling(studentOnboardingModal.familyId, pushNewCardToOnBoardingCardsAndCloseModal)
            },
        },
        leaving: {
            type: 'leaving',
            adminAssignable: false,
            schoolAssignable: true,
            introLessonDate: false,
            dropDownMenuOptions: [
                {
                    label: 'Make "Inquired"',
                    onClick: openMakeInquiredConfirmation
                },
                {
                    label: 'Move to scheduling',
                    onClick: () => moveWaitlistToScheduling(studentOnboardingModal.familyId, pushNewCardToOnBoardingCardsAndCloseModal)
                },
                {
                    label: 'Open Family Profile',
                    onClick: () => getFamilyData(studentOnboardingModal.familyId)
                },
            ],
            showCheckList: false,
            showMessageInsteadOfChecklist: 'Click the "To Scheduling" button to move this family to the scheduling workflow and off the Teacher Leaving list.',
            addTaskButton: false,
            moveForwardButton: {
                label: 'To Scheduling',
                onClick: () => fromLeavingToScheduling(studentOnboardingModal.familyId, 'scheduling', 'Reassign', pushNewCardAndRemoveGhostLeavingCardAndCloseModal)
            },
        },
    }

    const checkForAutoClear = (val) =>  val === "New Task..." && setOpenWorkflowModal2023({...studentOnboardingModal, todoName: ''})
    
    const changeTheOwner = (e) => setOpenWorkflowModal2023({...studentOnboardingModal, todoOwner: e})
    const changeTheSchool = (e) => setOpenWorkflowModal2023({...studentOnboardingModal, whichSchool: e})

    return(
        <div className='modal-area-fall-2023__wrapper' id='modal-area-fall-2023__wrapper'>
            {showInquiredReasonPopup && (
                <InquiredReasonPopup
                    title={`Why is the ${studentOnboardingModal.todoName} family being moved to Inquired?`}
                    onCancel={closeInquiredReasonPopup}
                    onConfirm={confirmMakeInquired}
                />
            )}
            <div
                className={`modal-area-fall-2023 ${teacherAssignmentControl ? 'modal-area-fall-2023--has-teacher-assignment' : ''}`}
                id='modal-area-fall-2023'
            >
                <div className='modal-area-fall-2023__header'>
                    <div className='modal-area-fall-2023__title-section'>
                        <div className='modal-area-fall-2023__title-section__text-wrapper'>
                            <div className='modal-area-fall-2023__title-section__column-badge-wrapper'>
                                <div className='modal-area-fall-2023__column-name'>{studentOnboardingModal.whichList.toUpperCase()}</div>
                                <TypeOfModalBadge2023 todoDescription={studentOnboardingModal.todoDescription} />
                            </div>
                                <input className='modal-area-fall-2023__task-name' value={studentOnboardingModal?.todoName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => setOpenWorkflowModal2023({...studentOnboardingModal, todoName: e.target.value})} />
                        </div>
                        <BsThreeDotsVertical onClick={() => setOpenDropdown(!openDropdown)} color='#94A3B8' cursor={'pointer'} size={24} />
                        {openDropdown && <ModalDropdownMenuFall2023 setOpenDropdown={setOpenDropdown} menuItems={cardLayout[studentOnboardingModal.whichList === 'student' ? 'scheduling' : studentOnboardingModal.whichList].dropDownMenuOptions} />}
                    </div>
                    <div className='modal-area-fall-2023__selector-area-wrapper'>
                        {
                        cardLayout[studentOnboardingModal.whichList === 'student' ? 'scheduling' : studentOnboardingModal.whichList].adminAssignable && 
                            <div className='modal-area-fall-2023__selector__admin'>
                                <DropdownWithImage options={modalOwnerOptions} value={studentOnboardingModal.todoOwner} onChange={changeTheOwner} />
                            </div>
                        }
                        {
                        cardLayout[studentOnboardingModal.whichList === 'student' ? 'scheduling' : studentOnboardingModal.whichList].schoolAssignable &&
                            <div className='modal-area-fall-2023__selector__school'>
                                <DropdownWithImage options={modalSchoolOptions} value={studentOnboardingModal.whichSchool} onChange={changeTheSchool} />
                            </div>
                        }
                        {contactPreferenceControl}
                    </div>
                    {teacherAssignmentControl}
                    {cardLayout[studentOnboardingModal.whichList].introLessonDate && 
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MuiPickerForCardModals
                                openModal2023={studentOnboardingModal}
                                setOpenModal2023={setOpenWorkflowModal2023}
                                label={cardLayout[studentOnboardingModal.whichList].datePickerLabel || 'Intro Lesson'}
                            />
                        </LocalizationProvider>
                    }
                </div>
                {cardLayout[studentOnboardingModal.whichList === 'student' ? 'scheduling' : studentOnboardingModal.whichList].showCheckList ? 
                    <div className='modal-area-fall-2023__subtask__wrapper'>
                        {studentOnboardingModal?.todoSubtasks.map((subtask) => <Subtask2023 key={subtask.subtaskId} subtask={subtask} openModal2023={studentOnboardingModal} setOpenModal2023={setOpenWorkflowModal2023} />)}
                        {cardLayout[studentOnboardingModal.whichList === 'student' ? 'scheduling' : studentOnboardingModal.whichList].addTaskButton && <div className='modal-area-fall-2023__add-subtask' onClick={() => setOpenWorkflowModal2023({...studentOnboardingModal, todoSubtasks: [...studentOnboardingModal?.todoSubtasks, freshSubtask()]})}>+ Task</div>}
                    </div>
                    :
                    <div className='modal-area-fall-2023__message-instead-of-checklist'>{cardLayout[studentOnboardingModal.whichList === 'student' ? 'scheduling' : studentOnboardingModal.whichList].showMessageInsteadOfChecklist}</div>
                }
                <div className='modal-area-fall-2023__bottom-btn-area'>
                {cardLayout[studentOnboardingModal.whichList].redButton && <PrimaryButtonLarge text={cardLayout[studentOnboardingModal.whichList].redButton.label} color={{background: 'bg-red-500', text: 'text-white'}} action={() => cardLayout[studentOnboardingModal.whichList].redButton.onClick()} />}
                {cardLayout[studentOnboardingModal.whichList].redButton && <div className='modal-area-fall-2023__bottom-btn-area__spacer'></div>}
                {cardLayout[studentOnboardingModal.whichList].neutralButton && <PrimaryButtonLarge text={cardLayout[studentOnboardingModal.whichList].neutralButton.label} color={'bg-red-500'} textColor={'text-white'} action={() => cardLayout[studentOnboardingModal.whichList].neutralButton.onClick()} />}
                    {
                    cardLayout[studentOnboardingModal.whichList === 'student' ? 'scheduling' : studentOnboardingModal.whichList].moveForwardButton &&
                    <div className='modal-area-fall-2023__bottom-btn-area__btn-wrapper'>
                        {
                        cardLayout[studentOnboardingModal.whichList === 'student' ? 'scheduling' : studentOnboardingModal.whichList].moveForwardButton.label !== 'Complete Onboarding' ? 
                            <ButtonWithTrailingIconXLarge text={cardLayout[studentOnboardingModal.whichList === 'student' ? 'scheduling' : studentOnboardingModal.whichList].moveForwardButton.label} color={'bg-teal-500'} textColor={'text-white'} action={() => cardLayout[studentOnboardingModal.whichList === 'student' ? 'scheduling' : studentOnboardingModal.whichList].moveForwardButton.onClick()} />
                        :
                            <PrimaryButtonLarge text={cardLayout[studentOnboardingModal.whichList === 'student' ? 'scheduling' : studentOnboardingModal.whichList].moveForwardButton.label} color={{background: 'bg-teal-500', text: 'text-white'}} action={() => cardLayout[studentOnboardingModal.whichList === 'student' ? 'scheduling' : studentOnboardingModal.whichList].moveForwardButton.onClick()} />
                        }
                    </div>
                    }
                </div>
            </div>
        </div>
    )

}
export default ModalAreaFall2023;
